export const getValueForRenderingInputOnChange = (value: unknown) => {
  const isValueChangeBeingIgnored = value === undefined || value === null;
  if (isValueChangeBeingIgnored) return "";
  return value;
};
